import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Asset } from 'src/app/interfaces/asset';
import { AdverticalService } from 'src/app/services/adverticalService/advertical.service';
import { AssetsService } from 'src/app/services/assetsService/assets.service';
import { CategoriesService } from 'src/app/services/categoriesService/categories.service';

@Component({
  selector: 'app-on-demand',
  templateUrl: './on-demand.component.html',
  styleUrls: ['./on-demand.component.less']
})
export class OnDemandComponent implements OnInit {
  catalogTitle;
  assets: Asset[] = new Array();
  private titleTimeout;
  private isLoading = false;
  private offset = 0;
  private count = 20;
  constructor(private activatedRoute: ActivatedRoute, private assetsService: AssetsService, private categoriesService: CategoriesService, private adverticalService: AdverticalService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.assets = new Array();
      this.isLoading = false;
      this.offset = 0;
      this.setCatalogTitle();
      this.getAssets();
      this.adverticalService.getBanner("Catalog_Banner", "CATALOG_BANNER", false);
    });
  }

  // Get assets from server
  getAssets() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.assetsService.getCatalogAssets({
      categoryId: this.activatedRoute.snapshot.params['id'],
      offset: this.offset,
      count: this.count
    }).then((resp: any) => {
      this.assets = this.assets && this.assets.length ? this.assets.concat(resp.assets) : resp.assets;
      this.isLoading = !resp.nextPage;
      this.offset += this.count
    });
  }

  // On Scroll down
  onScroll() {
    this.getAssets();
  };

  // Seting up the catalog title - To Do find a better way to update it in case of reload - no data
  setCatalogTitle() {
    const self = this;
    this.catalogTitle = this.categoriesService.getCategoryPath(Number(this.activatedRoute.snapshot.params['id']));
    if (!this.catalogTitle) {
      this.titleTimeout = setTimeout(function () {
        self.setCatalogTitle();
      }, 500);
    } else {
      clearTimeout(this.catalogTitle);
    }
  }
}